import { render, staticRenderFns } from "./nbEditfrom.vue?vue&type=template&id=24aed2e0&"
import script from "./nbEditfrom.vue?vue&type=script&lang=js&"
export * from "./nbEditfrom.vue?vue&type=script&lang=js&"
import style0 from "./nbEditfrom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports